import {AtendimentoDetalhes} from "./atendimento-detalhes";
import {ClienteContato} from "../../modules/cadastro/cliente/models/cliente-contato";
import {Log} from "./log";

export class ClienteDetalhes {
  nome: string;
  documento: string;
  tipoDocumento: number;
  tipoDocumentoDescricao: string;
  responsavel: string;

  atendimentos: AtendimentoDetalhes[] = [];
  contatos: ClienteContato[] = [];
  historico: Log[] = [];
}
